import { create } from "zustand";

type AppPreloadState = {
  revision: number;
  rerunPreload: () => void;
};

export const useAppPreloadStore = create<AppPreloadState>()((set) => ({
  revision: 0,
  rerunPreload: () =>
    set((state) => ({
      revision: state.revision + 1,
    })),
}));
